import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { BG } from "../MovingBg";

const SERVICES = [
  { title: "International Courier", sub: "Documents & parcels to 220+ countries", href: "/international-courier", testid: "service-card-intl",
    image: "https://images.unsplash.com/photo-1571086291540-b137111fa1c7?crop=entropy&cs=srgb&fm=jpg&q=85" },
  { title: "Domestic Courier", sub: "29,000+ Indian pincodes", href: "/domestic-courier", testid: "service-card-domestic",
    image: "https://images.unsplash.com/photo-1591768793355-74d04bb6608f?crop=entropy&cs=srgb&fm=jpg&q=85" },
  { title: "Air Express", sub: "Priority air freight", href: "/international-courier", testid: "service-card-air",
    image: "https://images.unsplash.com/photo-1556388158-158ea5ccacbd?crop=entropy&cs=srgb&fm=jpg&q=85" },
  { title: "Sea Cargo", sub: "FCL & LCL ocean freight", href: "/business-courier", testid: "service-card-sea",
    image: "https://images.unsplash.com/photo-1606964212858-c215029db704?crop=entropy&cs=srgb&fm=jpg&q=85" },
  { title: "eCommerce Shipping", sub: "Seller fulfilment & COD", href: "/ecommerce-shipping", testid: "service-card-ecom",
    image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?crop=entropy&cs=srgb&fm=jpg&q=85" },
  { title: "Business Courier", sub: "B2B & bulk logistics", href: "/business-courier", testid: "service-card-b2b",
    image: BG.warehouse },
  { title: "NRI Courier", sub: "Documents & personal effects", href: "/nri-courier", testid: "service-card-nri",
    image: BG.parcels },
  { title: "Customs Support", sub: "Clearance & documentation", href: "/business-courier", testid: "service-card-customs",
    image: BG.port },
];

export default function GlobalServices() {
  return (
    <section id="services" className="scroll-mt-24 bg-white py-20 sm:py-28" data-testid="global-services">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <p className="flex items-center gap-2 text-xs font-semibold text-slate-500">
          <span className="h-2 w-2 rounded-full bg-saffron" /> Our services
        </p>
        <div className="mt-4 flex flex-wrap items-end justify-between gap-4">
          <h2 className="font-heading text-3xl font-medium tracking-tight text-navy sm:text-5xl">
            One partner. <span className="text-saffron">Every delivery.</span>
          </h2>
          <Link to="/rate-calculator" data-testid="services-quote-link"
                className="group inline-flex items-center gap-2 rounded-full border border-stone-300 bg-white py-2 pl-5 pr-2 text-xs font-bold text-navy transition-colors hover:border-saffron hover:text-saffron">
            Get a quote
            <span className="grid h-7 w-7 place-items-center rounded-full bg-saffron/10 text-saffron transition-colors group-hover:bg-saffron group-hover:text-white">
              <ArrowRight className="h-3.5 w-3.5" />
            </span>
          </Link>
        </div>
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {SERVICES.map((s) => (
            <Link key={s.testid} to={s.href} data-testid={s.testid}
                  className="group rounded-2xl border border-stone-200 bg-white p-3 transition-all duration-300 hover:-translate-y-1 hover:border-saffron/40 hover:shadow-xl hover:shadow-stone-200">
              <div className="overflow-hidden rounded-xl">
                <img src={s.image} alt={`${s.title} — IndiaFast`} loading="lazy"
                     className="kenburns-a h-40 w-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
              <div className="flex items-center justify-between gap-3 px-2 pb-1.5 pt-4">
                <div>
                  <h3 className="font-heading text-base font-semibold text-navy">{s.title}</h3>
                  <p className="mt-0.5 text-xs text-slate-500">{s.sub}</p>
                </div>
                <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-saffron/10 text-saffron transition-colors group-hover:bg-saffron group-hover:text-white">
                  <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
